module.exports = __webpack_public_path__ + "static/img/21.afb7b44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/21.png
// module id = Ahmv
// module chunks = 0